import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Col, Row } from 'react-bootstrap';
import { numberFormat } from 'helpers/utils';

interface CrmStatCardProps {
  icon: IconProp;
  color: string;
  label: string;
  title: string;
  value: number;
  value2?: number;
}

const HVASystemKPICard2 = ({
  icon,
  color,
  label,
  title,
  value,
  value2
}: CrmStatCardProps) => {
  const formattedValue = title.toLowerCase().includes('time')
    ? (() => {
        if (value == null) return '0'; // Retorna un valor predeterminado si value es nulo o indefinido
        const hours = Math.floor(value);
        const minutes = Math.round((value - hours) * 60);
        return `${hours}h:${minutes}m`;
      })()
    : value != null
    ? numberFormat(value)
    : '0'; // Retorna un valor predeterminado si value es nulo o indefinido

  const formattedValue2 = title.toLowerCase().includes('time')
    ? (() => {
        if (value2 == null) return '0'; // Retorna un valor predeterminado si value es nulo o indefinido
        const hours = Math.floor(value2);
        const minutes = Math.round((value2 - hours) * 60);
        return `${hours}h:${minutes}m`;
      })()
    : value2 != null
    ? numberFormat(value2)
    : '0'; // Retorna un valor predeterminado si value es nulo o indefinido

  return (
    <Card>
      <Card.Body className="p-2 pt-0 pb-0">
        <Row className="mb-0">
          <Col
            className="d-flex align-items-center text-start px-0 pt-0 pb-1"
            xs={6}
            sm={6}
            md={6}
            xl={6}
            xxl={6}
          >
            <div
              className={`d-flex justify-content-center align-items-center pt-1`}
              style={{ width: '30px', minWidth: '30px' }}
            >
              <FontAwesomeIcon
                icon={icon}
                className={`text-${color} fs-7 z-1 ms-2`}
              />
            </div>
            <p className="text-body-tertiary fs-11 mb-0 ms-2 mt-2 lh-1">
              {label} <br />
              <span className="p-0 fs-8 fw-bold lh-1 text-body-emphasis">
                {title}
              </span>
            </p>
          </Col>
          <Col
            className={`d-flex flex-column mt-2 p-0 fs-7 fw-bold mb-0 pt-0 align-items-end`}
            xs={6}
            sm={6}
            md={6}
            xl={6}
            xxl={6}
          >
            <p className="text-body-tertiary fs-10 mb-1 ms-0 mt-auto lh-1 text-end">
              {value2 != null && (
                <>
                  <span className="fs-11">Tel. Nos.:</span> {formattedValue2}
                  <br />
                </>
              )}
              <span className={`p-0 fs-8 fw-bold lh-1 text-${color}`}>
                {formattedValue}
              </span>
            </p>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default HVASystemKPICard2;
